import { Component, OnInit, EventEmitter, Input, ViewChild, Output } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { ToastrService } from 'ngx-toastr';
import { Utility } from 'src/app/core/common';
import { AuthState } from 'src/app/states/auth.state';
import { JobService } from 'src/app/services/job.service';
import { SharedService } from 'src/app/services/shared.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-report-job',
  templateUrl: './report-job.component.html',
  styleUrls: ['./report-job.component.scss']
})
export class ReportJobComponent implements OnInit {

  constructor(private sharedService: SharedService, private jobService: JobService,private toastr: ToastrService) { 
    if (sharedService.isBrowser) {
      AuthState.user$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(async (user) => this.user = Utility.clone(user));
    }

  }
  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


  reportReasons = [
    'کلاهبرداری، نقض قوانین یا وقوع جرم',
    'کارفرما برای استخدام درخواست پول داشت',
    'استفاده غیرمجاز از نام شرکت شما',
    'کارفرما پاسخگو نیست',
    'کارفرما دیگه قصد استخدام نداره',
    'آگهی در سایت منبع موجود نیست',
    'موضوع آگهی، استخدام نیست'
  ];
  user: any;
  @Input() job: any;
  @Output() onReport = new EventEmitter<string>();
  @ViewChild('reportModal') reportModal: NgxSmartModalComponent;


  ngOnInit(): void {
  }

  open() {
    this.reportModal.open();
  }

  reportReason: string;
  async report() {
    await this.jobService.report(this.job.Id, this.reportReason);
    this.toastr.show('با تشکر از شما، گزارش تخلف از سمت شما ثبت شد');
    this.reportModal.close();
    this.onReport.emit(this.reportReason);
  }


}
